package com.macrofocus.eflux.ui

import com.macrofocus.eflux.components.EFluxContext
import com.macrofocus.eflux.components.PrimaryInfo
import com.macrofocus.eflux.components.SecondaryInfo
import com.macrofocus.eflux.components.blurBackground
import com.macrofocus.eflux.ui.perspective.About
import com.macrofocus.eflux.ui.perspective.Clock
import com.macrofocus.eflux.ui.perspective.Search
import i18next.invoke
import i18next.useTranslation
import mui.material.Box
import mui.material.Paper
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.SxProps
import mui.system.sx
import org.mkui.react.useProperty
import org.mkui.react.useSingleSelection
import react.FC
import react.PropsWithChildren
import react.useRequired
import web.cssom.*

external interface OverlayUIProps : PropsWithChildren {
}

public val OverlayUI = FC<OverlayUIProps> { props ->
    val infoBoxOnTheSide = true

    val context = useRequired(EFluxContext)
    val theme = useTheme<Theme>()
    val (t, _) = useTranslation()

    val (showAbout, _) = useProperty(context.showAbout)
    val (showSearch, _) = useProperty(context.showSearch)
    val (showClock, _) = useProperty(context.showClock)

    val (secondary, _) = useProperty(context.dataLoader.controller.secondary)
    val (primarySelection, _) = useSingleSelection(context.dataLoader.controller.primarySelection)

    val customBackground: (SxProps<Theme>) -> Unit = { it ->
        it.blurBackground(theme)
    }

    Box {
        sx {
            position = Position.relative
            width = 100.pct
            height = 100.vh // Fill entire viewport
            overflow = Overflow.hidden
            pointerEvents = None.none
        }

        // West container
        Paper {
            sx {
                position = Position.absolute
                top = 16.px
                left = 70.px
                width = 300.px
                display = Display.flex
                flexDirection = FlexDirection.column
                gap = 16.px

                pointerEvents = PointerEvents.visible

                customBackground(this)
            }

            if(showAbout) {
                Box {
                    sx {
                        marginTop = 8.px
                        marginLeft = 8.px
                    }

                    About {
                        guide = false
                        support = false
                    }
                }
            }
            if(showSearch) Search {}
            if(showClock)  {
                Box {
                    Clock {}
                }
            }

            if(showAbout) {
                AnchorItem {
                    //            classes,
                    id = "email"
                    label = t("appMenu.links.email")
                    href = "mailto:support@macrofocus.com"
                }
            }
        }

        if(context.dataLoader.controller.overlayProbing) {
            Box {
                sx {
                    position = Position.absolute
                    top = 16.px
                    right = 16.px
                    width = 300.px
                    height = Auto.auto
                }

                PrimaryInfo {
                    probing = null
                    selection = context.dataLoader.controller.primarySelection
                }
            }

            Box {
                sx {
                    position = Position.absolute
                    top = 16.px
                    if(infoBoxOnTheSide && primarySelection != null) {
                        right = 316.px
                    } else {
                        right = 16.px
                    }
                    width = 300.px
                    height = Auto.auto

                    // add a smooth transition on the `right` attribute
                    transition = "right 0.3s cubic-bezier(0.4, 0.0, 0.2, 1.0)".unsafeCast<Transition>()
                }

                PrimaryInfo {
                    probing = context.dataLoader.controller.primaryProbing
                    selection = null
                    ignoreProbing = if(infoBoxOnTheSide) context.dataLoader.controller.primarySelection else null
                    hideCrossborder = if(infoBoxOnTheSide) null else context.dataLoader.controller.primarySelection
                }
            }
        } else {
            Box {
                sx {
                    position = Position.absolute
                    top = 16.px
                    right = 16.px
                    width = 300.px
                    height = Auto.auto
                }

                PrimaryInfo {
                    probing = context.dataLoader.controller.primaryProbing
                    selection = context.dataLoader.controller.primarySelection
                }
            }
        }

        if(secondary) {
            Box {
                sx {
                    position = Position.absolute
                    top = 16.px
                    right = 316.px
                    width = 300.px
                }

                SecondaryInfo {
                }
            }
        }

        +props.children
    }
}